var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"circle",attrs:{"catchtap":"runAnimation"}},[_c('div',{staticClass:"left",style:({ backgroundColor: _vm.color })},[_c('div',{staticClass:"left-child",style:({
        transform: 'rotate(' + _vm.leftRotate + 'deg)',
        transition: 'all ' + _vm.aniTime / 1000 + 's liner'
      })})]),_c('div',{staticClass:"right",style:({ backgroundColor: _vm.color })},[_c('div',{staticClass:"right-child",style:({
        transform: 'rotate(' + _vm.rightRotate + 'deg)',
        transition: 'all ' + _vm.aniTime / 1000 + 's liner'
      })})]),_c('div',{staticClass:"percentage"},[_vm._v(_vm._s(_vm.data))])])}
var staticRenderFns = []

export { render, staticRenderFns }